import React, { useState } from "react";

// Componente del curso original - mantener para uso futuro
function CursoContenido() {
  const [formData, setFormData] = useState({
    nombre: "",
    apellido: "",
    edad: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL = "https://script.google.com/macros/s/AKfycbzJvD91Epv6ZGehQGn3zwwI6e---QPf2XVF-0_HKtAgv46NersmTc4pq8kEF8yJVneb/exec";

    try {
      await fetch(scriptURL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      localStorage.setItem("cursoRegistrado", "true");
      localStorage.setItem("nombreEstudiante", formData.nombre);

      window.location.href = "/registro-ok";

    } catch (error) {
      console.error("Error al enviar datos:", error);
      alert("Hubo un problema al registrar tus datos.");
    }
  };

  return (
    <main className="flex flex-col gap-8 p-6 text-white bg-gray-900 min-h-screen">
      <section className="text-center max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold mb-4 text-white drop-shadow-lg">
          El trading es la forma más difícil de ganar dinero fácil.
        </h1>
        <p className="text-lg text-gray-300 leading-relaxed">
          En este curso completamente <strong>gratuito</strong> podrás aprender todo lo necesario para iniciar tu camino en el trading. 
        </p>
        <p className="text-base text-gray-400 mt-4">
          Regístrate para acceder al curso. Es <strong>totalmente gratis</strong> y no necesitas experiencia previa.
        </p>
      </section>

      <section className="max-w-2xl mx-auto w-full bg-gray-800 rounded-2xl shadow-2xl p-8">
        <h2 className="text-3xl font-semibold text-white mb-6 text-center">
          Regístrate en el Curso
        </h2>

        <form onSubmit={handleSubmit} className="space-y-5">

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Nombre
            </label>
            <input
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 bg-gray-700 text-white border border-gray-600 rounded-lg"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Apellido
            </label>
            <input
              type="text"
              name="apellido"
              value={formData.apellido}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 bg-gray-700 text-white border border-gray-600 rounded-lg"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Edad
            </label>
            <input
              type="number"
              name="edad"
              value={formData.edad}
              onChange={handleChange}
              required
              min="18"
              className="w-full px-4 py-3 bg-gray-700 text-white border border-gray-600 rounded-lg"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Correo Electrónico
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 bg-gray-700 text-white border border-gray-600 rounded-lg"
            />
          </div>

          <button
            type="submit"
            className="w-full mt-6 px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600
            text-white font-semibold rounded-lg shadow-lg hover:scale-105 transition-all"
          >
            Registrarme en el Curso
          </button>
        </form>

        <p className="text-center text-sm text-gray-400 mt-4">
          Tu información está segura. No compartimos datos con terceros.
        </p>
      </section>
    </main>
  );
}

// Componente Próximamente que se exporta por defecto
function Curso() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white px-6">
      <div className="text-center max-w-md">
        <div className="mb-6 text-6xl">
          <span className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-yellow-500/20 border-2 border-yellow-500">
            🔨
          </span>
        </div>

        <h1 className="text-4xl font-bold mb-4">
          ¡Próximamente!
        </h1>

        <p className="text-xl text-gray-300 mb-2">
          Estamos trabajando en esta sección
        </p>
        <p className="text-gray-400 mb-8">
          Nos encontramos en pleno desarrollo. Vuelve pronto para acceder a nuestro curso completamente gratuito.
        </p>

        <div className="mt-8 p-6 bg-gray-800 rounded-lg">
          <p className="text-sm text-gray-300 mb-2">
            <strong>📧 Mantente informado:</strong>
          </p>
          <p className="text-xs text-gray-400">
            Suscríbete a nuestro canal de YouTube para recibir notificaciones cuando el curso esté disponible.
          </p>
        </div>

        <div className="mt-8">
          <a
            href="/"
            className="inline-block px-8 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold rounded-lg shadow-lg hover:scale-105 transition-all"
          >
            Volver al Inicio
          </a>
        </div>
      </div>
    </div>
  );
}

export default Curso;
export { CursoContenido };
